import AmexExperientialMGM from './AmexExperientialMGM';

export default AmexExperientialMGM;
